import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import Studio from '@/pages/home/components/Studio';
import Services from '@/pages/home/components/Services';
import Looks from '@/pages/home/components/Looks';
import Stylists from '@/pages/home/components/Stylists';
import Booking from '@/pages/home/components/Booking';
import Visit from '@/pages/home/components/Visit';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="bg-background-50 overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <Studio />
        <Looks />
        <Stylists />
        <Services />
        <Booking />
        <Visit />
      </main>
      <Footer />
    </div>
  );
}